import React from 'react';
import { Layout } from '../Layout';
import { Box, Typography } from '@mui/material';
import { Container, Header, SpaceBetween } from '@cloudscape-design/components';

export const Home: React.FC = () => {
    return (
        <Layout>
            <SpaceBetween direction="vertical" size="l">
                <Container
                    header={
                        <Header
                            variant="h2"
                        >
                            Welcome to KANJ Admin Portal
                        </Header>
                    }
                >
                </Container>
            </SpaceBetween>
        </Layout>
    );
}